<template>
  <aside class="Panel PanelQualiscore">
    <transition name="fade" appear v-if="data"><div class="Panel_cache" @click="closePanel"></div></transition>

    <transition name="fade" appear>
      <button class="Panel_close" @click="closePanel" v-if="data"><i class="fal fa-times"></i></button>
    </transition>

    <transition name="panel" appear>
      <div class="Panel_wrapper" v-if="data" ref="wrapper">
        <div class="Panel_content Panel_intro">
          <h6>En savoir plus</h6>
          <h3>La méthode de calcul du Qualiscore</h3>
          <p>Le Qualiscore est calculé selon 17 critères (confort thermique, qualité des matériaux…)</p>

          <div class="Slash Slash_grey"></div>
        </div>

        <div id="ListAdds" class="Panel_content Panel_content_grey">
          <div class="ListAdd">
            <div class="ListAdd_title">Qualité de la connexion internet</div>
            <div class="ListAdd_answer">Pas vraiment satisfait</div>
            <div class="ListAdd_more">+</div>
          </div>
          <div class="ListAdd">
            <div class="ListAdd_title">Qualité des matériaux</div>
            <div class="ListAdd_answer">Très satisfait</div>
            <div class="ListAdd_more">+</div>
          </div>
          <div class="ListAdd">
            <div class="ListAdd_title">Qualité de la sécurité électrique</div>
            <div class="ListAdd_answer">Pas du tout satisfait</div>
            <div class="ListAdd_more">+</div>
          </div>
          ...

          <div class="Slash Slash_white"></div>
        </div>

        <div class="Panel_content">
          <h4>Mais tous les critères ne comptent pas autant dans votre note !</h4>
          <p>Nous avons établi pour chacun des 17 critères un coefficient spécifique.</p>

          <div class="HouseBox">

            <div class="Slash Slash_grey"></div>

            <div class="HouseBox_wrapper">
              <img src="../../../public/static/images/illustrations/i_housebox.svg" />

              <div class="HouseBox_line">
                <div class="HouseBox_line_title"><b>Critère</b></div>
                <div class="HouseBox_line_value"><b>Coeff.</b></div>
              </div>
              <div class="HouseBox_line">
                <div class="HouseBox_line_title">1. Qualité des installations sanitaires</div>
                <div class="HouseBox_line_value">1,249</div>
              </div>
              <div class="HouseBox_line">
                <div class="HouseBox_line_title">2. Confort thermique</div>
                <div class="HouseBox_line_value">1,241</div>
              </div>
              <div class="HouseBox_line">
                <div class="HouseBox_line_title">...</div>
                <div class="HouseBox_line_value"></div>
              </div>
              <div class="HouseBox_line">
                <div class="HouseBox_line_title">17. Qualité de la connexion internet</div>
                <div class="HouseBox_line_value">0,473</div>
              </div>

            </div>
          </div>

        </div>

        <div class="Panel_content Panel_content_grey">
          <p><small>Par exemple, en fonction de sa contribution à votre satisfaction globale, le confort thermique a plus d’impact sur votre note que la qualité de votre connexion internet.</small></p>
          <hr>
          <p>Nous attribuons ensuite des points à chacun de ces critères en fonction de vos réponses. Le score obtenu est multiplié par le coefficient de ce critère.</p>
          <ul>
            <li>Très satisfait = 100</li>
            <li>Pas vraiment satisfait = 25</li>
            <li>Plutôt satisfait = 75</li>
            <li>Pas du tout satisfait = 0</li>
            <li>Ne sait pas = 50</li>
          </ul>
        </div>

        <div class="Panel_content">
          <div class="ButtonBox">
            <button class="QuizAnswer QuizAnswer_selected">
              <span>Très satisfait <b>Confort Thermique</b></span>
              <i class="far fa-check"></i>
            </button>

            <div class="Additions">
              <div class="Additions_item">
                <div class="Additions_item_value">100</div>
                <div class="Additions_item_label">satisfaction</div>
              </div>
              <div class="Additions_item">
                <div class="Additions_item_operator">x</div>
              </div>
              <div class="Additions_item">
                <div class="Additions_item_value">1,241</div>
                <div class="Additions_item_label">coefficient</div>
              </div>
              <div class="Additions_item">
                <div class="Additions_item_operator">=</div>
              </div>
              <div class="Additions_item">
                <div class="Additions_item_value">124,1</div>
              </div>
            </div>
          </div>

          <p>Pour terminer, nous additionnons tous les scores avant de transposer le score finale sur 10.</p>

          <div class="Additions">
              <div class="Additions_item">
                <div class="Additions_item_value">130</div>
                <div class="Additions_item_label">Confort<br>thermique</div>
              </div>
              <div class="Additions_item">
                <div class="Additions_item_operator">+</div>
              </div>
              <div class="Additions_item">
                <div class="Additions_item_value">67</div>
                <div class="Additions_item_label">Qualité des<br>matériaux</div>
              </div>
              <div class="Additions_item">
                <div class="Additions_item_operator">+</div>
              </div>
              <div class="Additions_item">
                <div class="Additions_item_value">...</div>
              </div>
              <div class="Additions_item">
                <div class="Additions_item_operator">=</div>
              </div>
              <div class="Additions_item">
                <div class="Additions_item_value">6,1<span>/ 10</span></div>
                <div class="Additions_item_label">Qualiscore</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </transition>

  </aside>
</template>

<script>
  import panel from '@/mixins/panel'

  export default {
    name: "PanelQualiscore",
    mixins: [ panel ],
    data() {
      return {
        data: false
      }
    },
    methods: {

    },
    mounted()
    {
      this.data = true
    }
  }
</script>

<style lang="stylus" scoped>
.PanelQualiscore

  .Additions

    display flex
    flex-direction row
    align-items stretch
    justify-content space-around
    padding 20px 0px
    width 100%

    &_item

      text-align: center;

      &_operator

        font-family $f-title
        font-weight 500
        font-size: 14px;
        color: $s1
        letter-spacing: -0.3px;
        line-height: 17px;
        position relative
        top 5px

      &_value

        font-family $f-title
        font-weight 500
        font-size: 24px;
        color: $blue
        letter-spacing: -0.3px;
        line-height: 30px;

        @media $small

          font-size 18px
          line-height 22px

        span

          font-size: 14px;
          color: $s1
          margin-left 3px

      &_label

        font-family $f-title
        font-weight normal
        font-size: 10px;
        color: $s1
        line-height: 14px;

  .ButtonBox

    position relative
    top -50px

    .Additions

      border-bottom 1px solid $n2

  .QuizAnswer

    position relative
    background: white;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
    border-radius: 5px;
    font-family $f-title
    letter-spacing -0.3px
    font-weight 500
    font-size 14px
    color $blue
    line-height 17px
    box-sizing border-box
    display block
    height 100px
    width 100%
    text-align center
    border 0px
    appearance none
    overflow hidden
    transition all 0.2s $ease

    span

      position relative
      display block
      font-size: 10px;
      line-height: 14px;
      text-transform uppercase
      transition transform 1s $ease

      b

        font-size: 14px;
        letter-spacing: -0.3px;
        line-height: 17px;
        text-transform none
        display block

    i

      font-size 18px
      position absolute
      top 50%
      left 50%
      color white
      opacity 0
      transform translate(-50%, 250%)
      transition opacity 0.5s $ease, transform 1s $ease


    &_selected

      background $blue
      color white

      span

        transform translateY(calc(-50% + 5px))

      i

        transform translate(-50%, 40%)
        opacity 1

  ul

    display flex
    flex-direction row
    align-items center
    justify-content space-between
    flex-wrap wrap
    margin 0px
    padding 0px
    list-style none
    margin 15px auto 0px auto
    padding-bottom 90px

    li

      width 50%
      font-family: $f-title
      font-weight 500
      font-size: 14px;
      margin-top 15px
      color: $blue
      letter-spacing: -0.3px;
      line-height: 17px;

  .HouseBox

    position relative
    margin-top 75px
    margin-bottom 20px

    &_wrapper

      background: #FFFFFF;
      box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
      border-radius: 5px;
      position relative
      padding 20px
      width 100%
      box-sizing border-box

    .Slash

      top 50px
      height 260px

    &_line

      display flex
      flex-direction row
      align-items flex-start
      justify-content space-between
      margin-top 10px

      &_title

        font-family $f-title
        font-weight 500
        font-size: 14px;
        color: $blue
        letter-spacing: -0.3px;
        line-height: 17px;

      &_value

        font-family $f-title
        font-weight 500
        font-size: 14px;
        color $red
        letter-spacing: -0.3px;
        line-height: 17px;

      &:first-child

        margin-top 0px

      b

        font-size: 10px;
        font-weight normal
        color: $s1
        text-transform uppercase
        letter-spacing: 0;
        line-height: 14px;

    img

      position absolute
      height 85px
      top -66px
      left 80px

  .Panel

    &_intro

      padding-bottom 90px

      p

        margin-bottom 0px

      .Slash

        top calc(100% - 30px)
        height 70px

  #ListAdds

    text-align center
    font-family $f-title
    font-size: 14px;
    color: #1F276D;
    font-weight 500
    padding-bottom 100px

    @media $small

      padding-bottom 50px
      margin-bottom 20px

.ie

  .PanelQualiscore .QuizAnswer_selected i

    transform translate(-50%, 120%)

</style>
